import React from 'react';
import { useFirmwareUpdateStore } from './FirmwareUpdate/state/use-firmware-update-store';
import DeviceWarningAlert from './DeviceWarningAlert';
import PaymentModal from '../../Payments/PaymentModal';
import { usePaymentsStore } from '../../Payments/state/use-payments-store';
import FirmwareUpdateModal from './FirmwareUpdate/FirmwareUpdateModal';
import DeviceWarningsModal from './DeviceWarnings/DeviceWarningsModal';
import { useDeviceWarningsStore } from './DeviceWarnings/state/use-device-warnings-store';
import { useFetchDeviceWarnings } from './DeviceWarnings/useFetchDeviceWarnings';

const ControllerAlerts = ({ device }) => {
  const openPaymentModal = usePaymentsStore((state) => state.openPaymentModal);
  const openFirmwareModal = useFirmwareUpdateStore((state) => state.open);
  const openWarningsModal = useDeviceWarningsStore((state) => state.open);
  const warnings = useDeviceWarningsStore((state) => state.warningsByDeviceId[device?.id]);

  useFetchDeviceWarnings(device?.id);

  return (
    <div className="flex items-center gap-1 ml-auto shrink-0">
      {device?.payment_required && (
        <DeviceWarningAlert
          tooltipText={'Устройство заблокировано:\nтребуется оплата NB‑IoT пакета'}
          colorClass="text-red-500"
          ariaLabel="Открыть оплату NB-IoT пакета"
          onOpen={openPaymentModal}>
          <PaymentModal />
        </DeviceWarningAlert>
      )}
      {Boolean(device?.update_required) && (
        <DeviceWarningAlert
          tooltipText={'Доступно обновление устройства:\nНастройте разрешение на обновление'}
          colorClass="text-orange-500"
          ariaLabel="Управление обновлением устройства"
          onOpen={() => openFirmwareModal(device)}>
          <FirmwareUpdateModal />
        </DeviceWarningAlert>
      )}
      {Boolean(warnings?.length) && (
        <DeviceWarningAlert
          tooltipText="Есть предупреждения по устройству"
          colorClass="text-red-500"
          ariaLabel="Открыть предупреждения по устройству"
          onOpen={() => openWarningsModal(device)}>
          <DeviceWarningsModal />
        </DeviceWarningAlert>
      )}
    </div>
  );
};

export default ControllerAlerts;
